module.exports = __webpack_public_path__ + "static/media/serviceProviderimg1.d0a5d336.png";